// extracted by mini-css-extract-plugin
module.exports = {"header":"ProgramItemHeader_header__2Y9nq"};